module.exports = __webpack_public_path__ + "img/pin-end.9b927fc7.png";